module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"label_Comune":"Comune"}}')
  delete Component.options._Ctor
}
